"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowTextEditor_1 = require("../../../../../../shared/components/editors/CardRowTextEditor");
var CardRowButtonSet_1 = require("../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var CardEditorContainer_1 = require("../../../../../../shared/components/containers/CardEditorContainer");
var CardRowCheckBoxEditor_1 = require("../../../../../../shared/components/editors/CardRowCheckBoxEditor");
var GwsGameProviderZonesEditor = /** @class */ (function (_super) {
    __extends(GwsGameProviderZonesEditor, _super);
    function GwsGameProviderZonesEditor(props) {
        return _super.call(this, props) || this;
    }
    GwsGameProviderZonesEditor.prototype.componentWillMount = function () {
        var _this = this;
        if (this.props.zoneRecord != null) {
            var _item = this.props.data.getById(this.props.zoneRecord.key);
            if (_item) {
                this.setState({
                    title: _item.title,
                    description: _item.description,
                    operator_id: _item.operator_id,
                    is_default_streamer_zone: _item.is_default_streamer_zone
                }, function () {
                    _this.props.state.setExtBreadCrumbPath(["Редактирование зоны шлюза"]);
                });
            }
        }
        else {
            this.setState({
                title: "",
                description: "",
                operator_id: "",
                is_default_streamer_zone: false
            }, function () {
                _this.props.state.setExtBreadCrumbPath(["Создание зоны шлюза"]);
            });
        }
        this.doReSetRules();
    };
    GwsGameProviderZonesEditor.prototype.doReSetRules = function () {
        this.setState({
            title_rules: { isError: false },
        });
    };
    GwsGameProviderZonesEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((!this.state.title) || (this.state.title.length === 0)) {
            this.setState({ title_rules: { isError: true, errorMessage: "Поле [название] не заполнено!" } });
            return false;
        }
        return true;
    };
    GwsGameProviderZonesEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditData({
                key: this.props.zoneRecord.key,
                description: this.state.description,
                title: this.state.title,
                operator_id: this.state.operator_id,
                is_default_streamer_zone: this.state.is_default_streamer_zone
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Зона геймпровайдера изменена!");
            });
        }
    };
    GwsGameProviderZonesEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                description: this.state.description,
                title: this.state.title,
                operator_id: this.state.operator_id,
                gws_gameprovider_id: this.props.rootRecord.key,
                is_default_streamer_zone: this.state.is_default_streamer_zone
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Зона геймпровайдера создана!");
            });
        }
    };
    GwsGameProviderZonesEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    GwsGameProviderZonesEditor.prototype.getFormTitle = function () {
        if (this.props.zoneRecord == null) {
            return "Новая зона геймпровайдера";
        }
        else {
            return "Изменить зону геймпровайдера";
        }
    };
    GwsGameProviderZonesEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 400 },
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Название:", placeholder: "Введите название" }, value: this.state.title, onValueChanged: function (newVal) { _this.setState({ title: newVal, title_rules: { isError: false } }); }, required: true, rules: this.state.title_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Operator id:", placeholder: "Введите operator id" }, value: this.state.operator_id, onValueChanged: function (newVal) { _this.setState({ operator_id: newVal }); } }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Описание:", placeholder: "Введите описание" }, value: this.state.description, onValueChanged: function (newVal) { _this.setState({ description: newVal }); } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Геймпровайдер для стримеров", value: this.state.is_default_streamer_zone, onChecked: function (checked) { _this.setState({ is_default_streamer_zone: checked }); } }),
            React.createElement(CardRowButtonSet_1.default, { editMode: this.props.zoneRecord != null, title: { btnEdit: "Сохранить", btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) })));
    };
    return GwsGameProviderZonesEditor;
}(React.Component));
exports.default = GwsGameProviderZonesEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gws_gameproviders_list/ui/component/GwsGameProviderZonesEditor.tsx
// module id = 1885
// module chunks = 0